export default {
    computed: {
        isMobile() {
            return this.$store.state.windowWidth <= 992 ? true : false;
        },
        noImageAvailable() {
            return "/images/icons/no-image-available.png";
        },
    },
    methods: {
        absoluteUrl(path = "") {
            if (!path) return this.$store.state.domain;

            const isAbsolute = /^(https?:\/\/)/i.test(path);
            return isAbsolute ? path : `${this.$store.state.domain}${path}`;
        },
        absoluteApiUrl(path) {
            return this.absoluteUrl(`/api${path || ""}`);
        },
        isImageFile(ext) {
            return ["png", "jpeg", "svg", "jpg", "webp"].includes(
                ext ? ext.toLowerCase() : null
            );
        },
        showProfileImg(image) {
            if (!image) {
                image = this.noImageAvailable;
            }
            let filePath = this.absoluteUrl(image);
            if (image.startsWith("http://") || image.startsWith("https://")) {
                filePath = image;
            }
            const data = { index: 0, visible: true, files: [filePath] };
            this.$store.commit("TOGGLE_LIGHT_BOX", data);
        },
        preText(content) {
            if (!content) return;
            const words = content.replace(/\n/g, " <br>").split(" ");
            const formattedWords = [];
            words.forEach((word) => {
                if (
                    word.startsWith("http://") ||
                    word.startsWith("https://") ||
                    word.startsWith("www.")
                ) {
                    formattedWords.push(
                        `<a href="${word}" class="text-primary" target="_blank"> ${word} </a>`
                    );
                } else {
                    formattedWords.push(word);
                }
            });
            return formattedWords.join(" ");
        },
        statusBadge(status) {
            if (!status) return;
            let codes = {
                pending: "#FFC107",
                active: "#0ec569",
                reviewed: "#41d051",
                confirmed: "#0ec569",
                dismissed: "#ff0002",
                draft: "#222222",
                approved: "#007d53",
                canceled: "#FF0000",
                closed: "#EF5350",
                suspended: "#ff0002",
                resolved: "#000000",
                rejected: "#ff0002",
                upcoming: "#FFC107",
                open: "#41d051",
                accepted: "#41d051",
                removed: "#ff0002",
                shortlisted: "#FFB02f",
                denied: "#ff0002",
                pending_approval: "#FFC107",
                applicant: "#4FC3F7",
                checked_out: "#66BB6A",
                accepted: "#28a745",
                enrolled: "#28a745",
                cancelled: "#EF5350",
                admitted: "#9575CD",
                collected: "#673ab7",
                invited_for_interview: "#007BFF",
                offered_employment: "#673ab7",
                scheduled: "#42A5F5",
                unused: "#AB47BC",
                used: "#28A745",
                rejected_shortlisting: "#ff0002",
                enrolled_in_training: "#28a745",
                unavailable: "#DC3545",
                not_verified: "#EA5455",
                verified: "#007d53",
                accepted_shortlisting: "#007d53",
                accepted_interview: "#007d53",
                employed: "#41d051",
                pending_acceptance: "#FFB02f",
                processing: "#20C997",
                graduated: "#28a745",
                in_progress: "#ffc107",
                deferred: "#17a2b8",
                applied: "#17a2b8",
                paid: "#41d051",
                enrolled_in_program: "#6F42C1",
                withdrawn: "#dc3545",
                dropped_out: "#343a40",
                suspended: "#fd7e14",
                rejected_by_employer: "#ff0002",
                selected_for_payment: "#6F42C1",
                live: "#28a745",
                ongoing: "#28a745",
                draft: "#ffc107",
                rejected_interview: "#ff0002",
                rejected_employment: "#ff0002",
                accepted_payment: "#007d53",
                rejected_payment: "#ff0002",
                acceptance_time_elapsed: "#ff0002",
            };
            return `<span style="background:${
                codes[status.toLowerCase()]
            }24; color:${
                codes[status]
            }; padding:0px 5px 2px 5px;line-height:1; border-radius:4px;">${status.replace(
                /_/g,
                " "
            )}</span>`;
        },
        scrollToView(elID) {
            if (!elID) {
                return;
            }
            const yOffset = -200;
            const element = document.getElementById(elID);
            const y =
                element.getBoundingClientRect().top +
                window.pageYOffset +
                yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
        },
        removeLeftOverBackDrop() {
            document
                .querySelectorAll(".modal-backdrop.show")
                .forEach(function (backdrop) {
                    backdrop.remove();
                });
            document.body.classList.remove("modal-open");
            document.body.style.overflow = "";
        },
        alertSuccess(text) {
            this.$store.dispatch("alertSuccess", text);
        },
        alertError(text) {
            this.$store.dispatch("alertError", text);
        },
        jsonToCSV(jsonData, delimiter = ",") {
            const headers = Object.keys(jsonData[0]);
            const csvRows = jsonData.map((row) => {
                return headers
                    .map((field) => {
                        const value = row[field] ? row[field] : "";
                        return JSON.stringify(value);
                    })
                    .join(delimiter);
            });
            return [headers.join(delimiter), ...csvRows].join("\n");
        },
        downloadCSV(csvString, filename = "data.csv") {
            // Create a blob of the CSV string
            const blob = new Blob([csvString], { type: "text/csv" });
            // Create a temporary link to trigger the download
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = filename;

            // Append the link, click it, and then remove it
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        confirmDelete(option) {
            return new Promise((resolve, reject) => {
                Swal.fire(
                    Object.assign(
                        {
                            title: "Are you sure?",
                            reverseButtons: true,
                            showCancelButton: true,
                            confirmButtonColor: "#f1556c",
                            cancelButtonColor: "#111",
                            confirmButtonText: "Delete it!",
                        },
                        option
                    )
                )
                    .then((result) => {
                        resolve(result);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        confirmAction(option) {
            return new Promise((resolve, reject) => {
                Swal.fire(
                    Object.assign(
                        {
                            title: "Confirm action!",
                            reverseButtons: true,
                            showCancelButton: true,
                            confirmButtonColor: "#225862",
                            cancelButtonColor: "#111",
                            confirmButtonText: "Yes, Proceed!",
                        },
                        option
                    )
                )
                    .then((result) => {
                        resolve(result);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        exelFileExport(payload) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(
                        `${payload.url}?${new URLSearchParams(
                            payload.data
                        ).toString()}`,
                        { responseType: "blob" }
                    )
                    .then((response) => {
                        if (response.status == 200) {
                            resolve(response);
                            const timestamp = new Date().getTime();
                            const filename =
                                (payload.filename || "") + timestamp + ".xlsx";

                            const blob = new Blob([response.data], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });
                            const link = document.createElement("a");
                            link.href = URL.createObjectURL(blob);
                            link.download = filename;
                            link.click();
                        } else {
                            throw new Error(
                                "Unexpected status code: " + response.status
                            );
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        pdfFileExport(payload) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(
                        `${payload.url}?${new URLSearchParams(
                            payload.data
                        ).toString()}`
                    )
                    .then((response) => {
                        if (response.data.success) {
                            resolve(response);
                            let filePath = this.absoluteUrl(
                                response.data.data.link
                            );
                            this.$store.commit("TOGGLE_PDF_MODAL_FRAME", {
                                visible: true,
                                filePath: filePath,
                            });
                        } else {
                            reject(response.data?.message);
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        readFileToBlob(payload) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(
                        `${this.absoluteUrl(
                            "/api/files"
                        )}?${new URLSearchParams(payload).toString()}`,
                        {
                            responseType: "blob",
                        }
                    )
                    .then((response) => {
                        if (response.status == 200) {
                            const file = new File(
                                [response.data],
                                payload.filename ||
                                    `file of ${response.data.type}`,
                                { type: response.headers["content-type"] }
                            );
                            resolve(file);
                        } else {
                            throw new Error(
                                "Unexpected status code: " + response.status
                            );
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
